export const POLLING_INTERVAL_MS = 5 * 60 * 1000;
export const VERSION_JSON_PATH = '/version.json';
